var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhoneUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.697 15.033a12.08 12.08 0 0 0 5.272 5.272l1.76-1.76a.8.8 0 0 1 .816-.2 9.1 9.1 0 0 0 2.856.456.8.8 0 0 1 .8.8v2.8a.8.8 0 0 1-.8.8A13.6 13.6 0 0 1 8.8 9.6a.8.8 0 0 1 .8-.8h2.8a.8.8 0 0 1 .8.8c0 1 .16 1.96.456 2.856a.8.8 0 0 1-.2.816z"
})));
export default SvgPhoneUser;